<template>
<div class="comment-modal__content">
  <div class="comment-modal__content__header">
    <div class="comment-modal-title">コメントを削除する</div>
  </div><!-- /.modal__content__header -->

  <div class="comment-modal__content__footer">
    <div class="comment-modal-btn-group">
      <button class="btn btn-edit" type="button" @click="hideModal"><span class="btn-text">キャンセル</span></button>
    </div>

    <div class="comment-modal-btn-group">
      <button class="btn btn-has-bg btn-delete" type="button" @click="deleteSet" :disabled="deleteDisabled"><span class="btn-text">削除する</span></button>
    </div>
  </div><!-- /.modal__content__footer -->
</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'modalDelete',
  data: function () {
    return {
      deleteDisabled: false
    }
  },
  computed: {
    ...mapState('modal', ['deleteUuid', 'deleteReplyKey'])
  },
  methods: {
    ...mapMutations('modal', ['hideModal']),
    ...mapActions('commentsData', ['commentDelete']),
    deleteSet: function () {
      // console.log(this.deleteUuid, 'deleteUuid')
      // console.log(this.deleteReplyKey, 'deleteReplyKey')
      // 返信か否か判定必要
      // this.commentDelete({'deleteUuid': this.deleteUuid, 'deleteReplyKey': this.deleteReplyKey})

      const payload = {
        'deleteUuid': this.deleteUuid,
        'deleteReplyKey': this.deleteReplyKey
      }
      // 処理中はdisabled
      this.deleteDisabled = true
      // 通信を待って処理
      this.commentDelete(payload).then(function (isDeleteSuccess) {
        // console.log('Deleteからの戻り', isDeleteSuccess)
        // 戻りあれば無条件でdisabled解除
        this.deleteDisabled = false
      }.bind(this))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/modal/modalDelete.vue